import React, { Fragment, useEffect } from "react";
import { render } from "react-dom";
import App from "./Web/Layout/App";
import { Toaster } from "react-hot-toast";
import {
  BrowserRouter,
  Route,
  Routes,
  Switch,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { routes } from "./Web/Router/Route";
import { Provider, useDispatch, useSelector } from "react-redux";
import { createStore } from "redux";
import rootReducer from "./reducers";
import MainContext from "./Context/MainContext";
import AfterPayment from "./Web/View/AfterPayment";
import { GetData } from "./Web/Components/Services";
import NotFound from "./Web/View/NotFound/index";
import "./assets/css/main.scss";
import "./assets/styles/index.scss";
import { routes as routesAdmin } from "./Panel/Admin/Router/Route";
import AdminApp from "./Panel/Common/Components/App/index";
import { RoutesUser } from "./Panel/User/Router/Route";
import { handleSubscription } from "./subscription";

Object.defineProperty(Object.prototype, "toFormData", {
  value: function () {
    const formData = new FormData();
    const binder = (data, parentKey) => {
      if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File) &&
        !(data instanceof Blob)
      ) {
        Object.keys(data).forEach((key) => {
          binder(data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
      } else {
        const value =
          data === null ? "" : data instanceof Date ? data.toISOString() : data;
        formData.append(parentKey, value);
      }
    };
    binder(this);
    return formData;
  },
  enumerable: false,
});
const store = createStore(rootReducer);
const Middleware = (user_type, user = {}) => {
  const { status, role, item } = user;
  const handleAtheletes = (route) => {
    if (item[0].timetabletype === "active") {
      if (route.needdate && item[0].timetable_option["needdate"] == "false") {
        return route;
      }
      if (item[0].timetable_option[route.time] == "true") {
        if (route.model) {
          if (item[0].timetable_showmodel == route.model) {
            return route;
          } else {
            return;
          }
        } else {
          return route;
        }
      } else {
        return;
      }
    } else {
      return;
    }
  };

  const filterRoutes = () => {
    if (status == "active") {
      if (role == "manager" && item.length > 1) {
        return RoutesUser.filter((ro) => ro.path === "/User/Dashboard");
      } else {
        return RoutesUser.map((route) => {
          if (
            (route.type && route.type[0] == "default") ||
            (route.type && route.type.includes(role))
          ) {
            if (route.time) {
              return handleAtheletes(route);
            } else {
              return route;
            }
          } else {
          }
        }).filter(Boolean);
      }
    } else {
      return [];
    }
  };
  if (user) {
    switch (user_type) {
      case "admin":
        return (
          <Fragment>
            {routesAdmin.map((route, idx) => {
              if (route.component) {
                return (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={
                      <AdminApp routes={routesAdmin}>
                        <route.component />
                      </AdminApp>
                    }
                  />
                );
              }
            })}
          </Fragment>
        );
      default:
        return (
          <Fragment>
            {filterRoutes().map((route, idx) => {
              if (route.component) {
                return (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={
                      <AdminApp routes={filterRoutes()}>
                        <route.component />
                      </AdminApp>
                    }
                  />
                );
              }
            })}
          </Fragment>
        );
    }
  } else {
    return null;
  }
};
const BODY = () => {
  const dispatch = useDispatch();
  localStorage.setItem("isApp", false);

  const { user, user_type, footerDetails } = useSelector((state) => state);

  const handler = () => {
    GetData().then((result) => {
      if (result) {
        dispatch({
          type: "SET",
          payload: { footerDetails: result },
        });
      }
    });
  };

  useEffect(() => {
    if (!footerDetails) {
      handler();
    }
  }, []);

  useEffect(() => {
    // enableNotif();
  }, []);

  const checkHeaderFooter = (name) => {
    const auths = [
      "AdminnLoginn",
      "ticket",
      "PayResult",
      "Contractregistore",
      "NewContract",
      "MenuContract",
      "ExiteAcoounte",
    ];
    let res = false;
    auths.map((route) => {
      if (route == name) {
        res = true;
      }
    });
    return res;
  };

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<NotFound />} />

          {routes.map((route, idx) => {
            return (
              <Route
                key={idx}
                path={route.path}
                exact={route.exact}
                name={route.name}
                element={
                  <App noFoooter={checkHeaderFooter(route.name)}>
                    <route.component />
                  </App>
                }
              />
            );
          })}
          <Route
            element={
              <App noFoooter={checkHeaderFooter("PayResult")}>
                <AfterPayment />
              </App>
            }
            path={"/pay/result"}
            exact
          />
          {Middleware(user_type, user || {})}
        </Routes>

        <Toaster />
      </BrowserRouter>
    </>
  );
};

const mobileAndTabletCheck = () => {
  let check = false;

  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;

  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
};

async function enableNotif() {
  try {
    await handleSubscription();
  } catch (error) {
    // console.log(error);
    // console.log("Error in componentDidMount, error");
  }
}

const AppBody = () => {
  localStorage.setItem("isApp", true)
  const AppMobile = React.lazy(() => import("./App"));

  useEffect(() => {
    // enableNotif();
  }, []);

  return (
    <React.Suspense fallback={<></>}>
      <AppMobile />
      <Toaster />
    </React.Suspense>
  );
};
render(
  <Provider store={store}>
    <MainContext>{mobileAndTabletCheck() ? <AppBody /> : <BODY />}</MainContext>
  </Provider>,
  document.getElementById("root")
);
